import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { RoleEntity } from "./role-entity";
import { RoleDto } from "./role-dto";
import {
  AllRolesResponseModel,
  CommonResponseModel,
  RolesData,
} from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";

@Injectable()
export class RoleService {
  constructor(
    @InjectRepository(RoleEntity)
    private rolesRepository: Repository<RoleEntity>
  ) {}

  async createRole(
    data: RoleDto,
    isUpdate: boolean
  ): Promise<AllRolesResponseModel> {
    try {
      const roles = new RoleEntity();
      roles.role = data.role;
      roles.unit = data.unit;
      // roles.plantId = data.plantId;
      roles.isActive = data.isActive;
      if (isUpdate) {
        roles.id = data.id;
        roles.updatedUser = data.updatedUser;
      } else {
        roles.createdUser = data.createdUser;
      }
      const save = await this.rolesRepository.save(roles);
      if (save) {
        return new AllRolesResponseModel(
          true,
          0,
          isUpdate ? "Roles Updated Successfully" : "Roles Created Successfully"
        );
      }
    } catch (error) {
      throw error;
    }
  }

  async getActiveAllRoles(): Promise<CommonResponseModel> {
    const data = await this.rolesRepository.find({
        where: {
            isActive: true
        }
    })

    if (data.length > 0) {
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
    }
    return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
}

  async updateRole(req: RoleDto): Promise<CommonResponseModel> {
    try {
      let role;
      role = await this.rolesRepository.update(
        { id: req.id },
        { role: req.role, unit: req.unit }
      );
      if (role.affected > 0) {
        return new CommonResponseModel(true, 11, "updated successfully", role);
      } else {
        return new CommonResponseModel(false, 11, "uploaded failed", []);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getAllRoles(): Promise<CommonResponseModel> {
    const data = await this.rolesRepository.find();
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async activateOrDeactivateRole(req: RolesData): Promise<CommonResponseModel> {
    // add dto
    try {
      // console.log(req.isActive, "service-----------");
      const Exists = await this.rolesRepository.findOne({
        where: { id: req.id },
      });
      if (Exists) {
        if (!Exists) {
          throw new ErrorResponse(
            10113,
            "Someone updated the current Role information.Refresh and try again"
          );
        } else {
          const update = await this.rolesRepository.update(
            { id: req.id },
            { isActive: req.isActive, updatedUser: req.updatedUser }
          );
          if (Exists.isActive) {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10115,
                "Role is Deactivated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10111,
                "Role is already deactivated"
              );
            }
          } else {
            if (update.affected) {
              const Response: CommonResponseModel = new CommonResponseModel(
                true,
                10114,
                "Role is activated successfully"
              );
              return Response;
            } else {
              throw new CommonResponseModel(
                false,
                10112,
                "Role is already  activated"
              );
            }
          }
        }
      } else {
        throw new CommonResponseModel(false, 99998, "No Records Found");
      }
    } catch (err) {
      return err;
    }
  }

  // async activateOrDeactivateRole(req: RolesData): Promise<CommonResponseModel> {
  //   const record = await this.rolesRepository.findOne({
  //     where: { id: req.id },
  //   });
  //   await this.rolesRepository.update(
  //     { id: req.id },
  //     { isActive: !record.isActive }
  //   );
  //   const internalMessage: string = !record.isActive
  //     ? "Activated Sucessfully"
  //     : "Deactivated Successfully";
  //   return new CommonResponseModel(true, 6876, internalMessage);
  // }
}
